////////LIBRARY/////////
import { split, isString } from 'lodash'

class TextParser {
	static textFormat(text) {
		let textToFormat = text
		// guard
		if (!isString(text)) {
			textToFormat = ''
		}

		return split(textToFormat, '%%')
	}
}

export default TextParser
